import { Text } from '@kanda-libs/ks-design-library';
import clsx from 'clsx';

interface GridComponentProps {
  title: string;
  component: JSX.Element;
  className?: string;
  isLoading: boolean;
  labelColor?: string;
}

const GridComponent = ({
  title,
  component,
  className,
  isLoading,
  labelColor = 'text-neutral-600',
}: GridComponentProps) => (
  <div className={`flex flex-col ${className || ''}`}>
    <Text
      isLoading={isLoading}
      text={title}
      className={clsx('text-10-17-em-up', labelColor)}
    />
    {component}
  </div>
);

export default GridComponent;
